import React, { useEffect, useContext, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';

import TabContainer from 'containers/TabContainer/TabContainer';
import ContextStore from 'modules/context';

function SettingCustomer() {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { setBreadcrumbs } = useContext(ContextStore)
  const location = useLocation()
  const pathname = location.pathname
  const [activeTabIndex, setActiveTabIndex] = useState(undefined)

  let defaultSelect
  if (pathname === '/setting/customer/extData') {
    defaultSelect = 0
  } else if (pathname === '/setting/customer/customerType') {
    defaultSelect = 1
  }  else if (pathname === '/setting/customer/print') {
    defaultSelect = 2
  }

  useEffect(() => {
    setBreadcrumbs([{
      text: formatMessage({ id: 'sideMenu.setting.root' })
    }])
  }, [pathname]);

  useEffect(() => {
    if (pathname === '/setting/customer/extData' && activeTabIndex !== 0) {
      setActiveTabIndex(0)
    } else if (pathname === '/setting/customer/customerType' && activeTabIndex !== 1) {
      setActiveTabIndex(1)
    } else if (pathname === '/setting/customer/print' && activeTabIndex !== 2) {
      setActiveTabIndex(2)
    }

    return () => {
    };
  }, [pathname]);

  const onTabSelected = (tabIndex) => {
    if (tabIndex === 0) {
      navigate('/setting/customer/extData');
    } else if (tabIndex === 1) {
      navigate('/setting/customer/customerType');
    } else if (tabIndex === 2) {
      navigate('/setting/customer/print');
    }
  }

  const tabs = [
    {
      label: formatMessage({ id: 'setCustomer.extData.title' }),
      component: <Outlet />
    },
    {
      label: formatMessage({ id: 'setCustomer.customerType.title' }),
      component: <Outlet />
    },
    {
      label: formatMessage({ id: 'setCustomer.print.title' }),
      component: <Outlet />
    },
  ]

  return (
    <div style={{ padding: '12px 24px 80px 24px' }}>
      <Toolbar sx={{ pl: 2, pr: 1 }}>
        <Typography sx={{ flex: '1 1 100%', flexShrink: 2 }} variant="h6" id="tableTitle" component="div">
          <FormattedMessage id="setCustomer.title" />
        </Typography>
      </Toolbar>
      <TabContainer activeTabIndex={activeTabIndex} defaultSelect={defaultSelect} tabs={tabs} onTabSelected={onTabSelected} />
    </div>
  );
}

export default SettingCustomer;
